import { createSlice } from "@reduxjs/toolkit";
import getUserDetail from "../../utils/getUserDetail";
import { setItem, removeItem } from "../../utils/cooke-data";

const user = getUserDetail();

const initialState = {
  user: user ? user : null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      setItem("user", action.payload);
    },
    clearUser: (state) => {
      state.user = null;
      removeItem("user");
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
